import { render } from "./addNormal.vue?vue&type=template&id=69293d37&scoped=true"
import script from "./addNormal.vue?vue&type=script&lang=js"
export * from "./addNormal.vue?vue&type=script&lang=js"

import "./addNormal.vue?vue&type=style&index=0&id=69293d37&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69293d37"]])

export default __exports__